import React from 'react';
import PropTypes from 'prop-types';
import InputAdornment from '@material-ui/core/InputAdornment';
import hasGrade from '$utils/hasGrade';
import GradeInput from '../GradeInput';

import parsePercentageGrade from '../utils/parsePercentageGrade';

const Percentage = ({ onBlur, onChange, grade, error }) => {
  const handleChange = ({ target: { value } }) => {
    // support empty value to unset a grade
    if (value === '') {
      onChange();
      return;
    }

    const validatedGrade = parsePercentageGrade(value);

    if (hasGrade({ displayGrade: validatedGrade })) {
      onChange(validatedGrade);
    }
  };

  return (
    <GradeInput
      inputAdornment={<InputAdornment position="end">%</InputAdornment>}
      onChange={handleChange}
      onBlur={onBlur}
      grade={grade}
      width={70}
      label="percentage grade input"
      error={error}
    />
  );
};

Percentage.propTypes = {
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  grade: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string, // to allow empty string to unset a grade
  ]),
  error: PropTypes.bool,
};

Percentage.defaultProps = {
  grade: '',
  error: false,
};

export default Percentage;
